export const POPUP_WIDTH = 491;

export const TABS = {
  anyword: 0,
  custom: 1,
};
